import type { NlsKey } from '../nls/strings_nls'
import type { WorkspaceRole } from '../types/workspace'
import { isWorkspaceRole } from './workspacePermissions'

export const roleLabelKey = (role: WorkspaceRole): NlsKey => {
  switch (role) {
    case 'OWNER':
      return 'NLSRoleOwner'
    case 'ADMIN':
      return 'NLSRoleTeamAdmin'
    case 'EDITOR':
      return 'NLSRoleEditor'
    case 'VIEWER':
      return 'NLSRoleViewer'
    case 'READONLY':
      return 'NLSRoleReadonly'
    case 'HELPER':
      return 'NLSRoleHelper'
    case 'LEARNER':
      return 'NLSRoleLearner'
  }
}

export const formatRoleLabel = (t: (key: NlsKey) => string, role: unknown): string => {
  if (isWorkspaceRole(role)) {
    return t(roleLabelKey(role))
  }
  if (typeof role === 'string') {
    return role
  }
  return ''
}

